import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import moment from "moment-timezone";

import breakpoints from "_constants/breakpoints";

import { currencyFormatter } from "_helpers";

import { CancelButton } from "widget/Buttons";
import { Link } from "react-router-dom";

const OrderContainer = styled.div`
  width: 100%;
  padding: 18px;
  border-bottom: 1px solid #ecedf1;
  ${({ index }) =>
    index % 2 !== 0 &&
    css`
      background-color: #fafaff;
    `}
  &:first-child {
    border-top: 1px solid #ecedf1;
  }

  @media (max-width: ${breakpoints.mobileM}) {
    padding: 24px 0px;
  }
`;
const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  min-height: 24px;
  &:not(:last-child) {
    margin-bottom: 15px;
  }
  ${({ right }) =>
    right &&
    css`
      justify-content: right;
      padding-top: 16px;
    `}

  @media (max-width: ${breakpoints.mobileM}) {
    gap: 12px;

    &:not(:last-child) {
      margin-bottom: 8px;
    }
  }
`;
const Cell = styled.div`
  text-align: left;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #7b848d;

  @media (max-width: ${breakpoints.mobileM}) {
    width: 100%;
  }
`;
const DateCell = styled(Cell)`
  text-transform: uppercase;
`;
const Label = styled(Cell)`
  min-width: 120px;
  font-weight: bold;

  @media (max-width: ${breakpoints.mobileM}) {
    min-width: 80px;
  }
`;
const StyledCancelButton = styled(CancelButton)`
  @media (max-width: ${breakpoints.mobileM}) {
    width: 100%;
    max-width: 90px;
  }
`;
const LinkText = styled(Link)`
  font-weight: bold;
  font-size: 13px;
  color: #03589c;
`;

const ActiveText = styled.span`
  font-weight: bold;

  ${({ children }) =>
    children === "ACTIVE" &&
    css`
      color: green;
    `}

  ${({ children }) =>
    children === "CANCELLED" &&
    css`
      color: red;
    `}
`;

function Subscription({ index, id, orderId, productName, productId, nextPayDate, price, status, onCancel }) {
  return (
    <OrderContainer index={index}>
      <Row>
        <Label>Order ID</Label>
        <DateCell>{orderId}</DateCell>
      </Row>

      <Row>
        <Label>Product Name</Label>
        <Cell>
          <LinkText to={id && productId ? `${id}/${productId}` : "#"}>{productName}</LinkText>
        </Cell>
      </Row>
      <Row>
        <Label>Price</Label>
        <Cell>{currencyFormatter(price)}</Cell>
      </Row>
      <Row>
        <Label>Next Billing Date</Label>
        <Cell>{nextPayDate && nextPayDate !== "null" ? moment(nextPayDate).format("MMM DD, YYYY") : "—"}</Cell>
      </Row>
      <Row>
        <Label>Status</Label>
        <Cell>
          <ActiveText>{status}</ActiveText>
        </Cell>
      </Row>
      {!!id && !!productId && nextPayDate && nextPayDate !== "null" && (
        <Row>
          <Label></Label>
          <Cell>
            <StyledCancelButton onClick={() => onCancel({ id, productId, productName })} />
          </Cell>
        </Row>
      )}
    </OrderContainer>
  );
}

Subscription.propTypes = {
  index: PropTypes.number.isRequired,
  id: PropTypes.string,
  orderId: PropTypes.string,
  productId: PropTypes.string,
  productName: PropTypes.string,
  nextPayDate: PropTypes.string,
  price: PropTypes.number.isRequired,
  status: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
};

function SubscriptionsMobile({ subscriptions, onCancel }) {
  return (
    <>
      {subscriptions.map((order, idx) => (
        <Subscription key={idx} index={idx} onCancel={onCancel} {...order} />
      ))}
    </>
  );
}

SubscriptionsMobile.propTypes = {
  subscriptions: PropTypes.arrayOf(PropTypes.object),
  onCancel: PropTypes.func,
};

export default SubscriptionsMobile;
